import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "../components/Login";
import BookingLayout from "../page/layout/BookingLayout";
import Dashboard from "../page/Dashboard";
import Booking from "../page/Booking/layout/BookingPage";
import Add from "../page/Booking/Add";
import New from "../page/Booking/New";
import Live from "../page/Booking/Live";
import Completed from "../page/Booking/Completed";
import Enquiry from "../page/Booking/Enquiry";
import Cancel from "../page/Booking/Cancel";
import DriverAttendance from "../page/DriverAttendance";
import DriverCall from "../page/DriverReport_Layout/DriverCall";
import AddDrivers from "../page/DriverReport_Layout/AddDrivers";
import AEnquiry from "../page/Attachment_Enquiry/Attachment enquiry";
import AddAttachmentenquiry from "../page/Attachment_Enquiry/AddAttachmentenquiry";
import DriverReportLayout from "../page/DriverReport_Layout/Layout/DriverReportLayout";
import AttachmentLayout from "../page/Attachment_Enquiry/Layout/AttachmentLayout";
import ProtectedRoute from "./ProtectedRoute";
import EnterpriseEnquiry from "../page/EnterpriseEnquiry";
import AvailableCabs from "../page/AvailableCabs";
import { usePresenceHeartbeat } from "../utils/hooks/usePresence";

const AppRoutes = () => {
  usePresenceHeartbeat();

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute menuId={1}>
            <BookingLayout>
              <Dashboard />
            </BookingLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/driverattendance"
        element={
          <ProtectedRoute menuId={3}>
            <BookingLayout>
              <DriverAttendance />
            </BookingLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/driverreport"
        element={
          <ProtectedRoute menuId={4}>
            <BookingLayout>
              <DriverReportLayout />
            </BookingLayout>
          </ProtectedRoute>

        }
      >
        <Route index element={<Navigate to="add-driver" replace />} />
        <Route path="driver-call" element={<DriverCall />} />
        <Route path="add-driver" element={<AddDrivers />} />
      </Route>

      <Route
        path="/aenquiry"
        element={
          <ProtectedRoute menuId={5}>
            <BookingLayout>
              <AttachmentLayout />
            </BookingLayout>
          </ProtectedRoute>

        }
      >
        <Route index element={<Navigate to="add-enquiry" replace />} />
        <Route path="AEnquiry" element={<AEnquiry />} />
        <Route path="add-enquiry" element={<AddAttachmentenquiry />} />
      </Route>

      <Route
        path="/EnterpriseEnquiry"
        element={
          <ProtectedRoute menuId={6}>
            <BookingLayout>
              <EnterpriseEnquiry />
            </BookingLayout>
          </ProtectedRoute>

        }
      />

      <Route
        path="/AvailableCabs"
        element={
          <ProtectedRoute menuId={7}>
            <BookingLayout>
              <AvailableCabs />
            </BookingLayout>
          </ProtectedRoute>

        }
      />

      <Route
        path="/booking"
        element={
          <ProtectedRoute menuId={2}><BookingLayout>
            <Booking />
          </BookingLayout>
          </ProtectedRoute>

        }
      >
        <Route index element={<Navigate to="add" replace />} />

        <Route path="add" element={<Add />} />
        <Route path="new" element={<New />} />
        <Route path="live" element={<Live />} />
        <Route path="completed" element={<Completed />} />
        <Route path="enquiry" element={<Enquiry />} />
        <Route path="cancel" element={<Cancel />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
